document.addEventListener("DOMContentLoaded", () => {

    /* ==========================================
       ELEMENTS
    ========================================== */

    const loader =
        document.getElementById("hgpCartLoader");

    const loaderTitle =
        loader?.querySelector(
            ".hgp-cart-loader-title"
        );

    const loaderText =
        loader?.querySelector(
            ".hgp-cart-loader-text"
        );


    /* ==========================================
       REVEAL ANIMATION
    ========================================== */

    const cards =
        document.querySelectorAll(
            ".hgp-bs-card"
        );


    if (cards.length) {

        const observer =
            new IntersectionObserver(
                (entries) => {

                    entries.forEach(
                        (entry) => {

                            if (
                                !entry.isIntersecting
                            ) {
                                return;
                            }


                            entry.target.classList.add(
                                "show"
                            );


                            observer.unobserve(
                                entry.target
                            );

                        }
                    );

                },
                {
                    threshold: 0.15
                }
            );


        cards.forEach(
            (card, index) => {

                card.style.transitionDelay =
                    `${index * 80}ms`;


                observer.observe(
                    card
                );

            }
        );

    }


    /* ==========================================
       SHOW LOADER
    ========================================== */

    function showCartLoader() {

        if (!loader) return;


        loader.classList.remove(
            "success"
        );


        if (loaderTitle) {

            loaderTitle.textContent =
                "Loading";

        }


        if (loaderText) {

            loaderText.textContent =
                "Adding to cart...";

        }


        loader.classList.add(
            "active"
        );


        loader.setAttribute(
            "aria-hidden",
            "false"
        );


        document.body.style.overflow =
            "hidden";

    }


    /* ==========================================
       SHOW SUCCESS
    ========================================== */

    function showCartSuccess() {

        if (!loader) return;


        loader.classList.add(
            "success"
        );


        if (loaderTitle) {

            loaderTitle.textContent =
                "Added to Cart";

        }


        if (loaderText) {

            loaderText.textContent =
                "Your item is now in your cart.";

        }

    }


    /* ==========================================
       HIDE LOADER
    ========================================== */

    function hideCartLoader() {

        if (!loader) return;


        loader.classList.remove(
            "active",
            "success"
        );


        loader.setAttribute(
            "aria-hidden",
            "true"
        );


        document.body.style.overflow =
            "";

    }


    /* ==========================================
       UPDATE HEADER CART
    ========================================== */

    async function updateHeaderCart() {

        try {

            const response =
                await fetch(
                    "/cart.js",
                    {
                        headers: {
                            "Accept":
                                "application/json"
                        }
                    }
                );


            if (!response.ok) {

                throw new Error(
                    "Unable to fetch cart."
                );

            }


            const cart =
                await response.json();


            const cartCount =
                document.querySelector(
                    "[data-cart-count]"
                );


            if (cartCount) {

                cartCount.textContent =
                    cart.item_count;


                cartCount.classList.toggle(
                    "is-empty",
                    cart.item_count === 0
                );


                cartCount.classList.remove(
                    "cart-count-pop"
                );


                void cartCount.offsetWidth;


                cartCount.classList.add(
                    "cart-count-pop"
                );

            }


            return cart;

        }

        catch (error) {

            console.error(
                "Cart update error:",
                error
            );


            return null;

        }

    }


    /* ==========================================
       PREMIUM CART CELEBRATION
    ========================================== */

    function celebrateCart() {

        const cartButton =
            document.querySelector(
                ".hgp-cart-icon-btn"
            );


        if (!cartButton) return;


        cartButton.classList.remove(
            "cart-celebrate"
        );


        void cartButton.offsetWidth;


        cartButton.classList.add(
            "cart-celebrate"
        );


        setTimeout(() => {

            cartButton.classList.remove(
                "cart-celebrate"
            );

        }, 4000);

    }


    /* ==========================================
       AJAX ADD TO CART
    ========================================== */

    document
        .querySelectorAll(
            ".hgp-bs-cart"
        )
        .forEach((button) => {

            button.addEventListener(
                "click",
                async (event) => {

                    event.preventDefault();


                    const variantId =
                        button.dataset.variant;


                    if (!variantId) return;


                    button.disabled = true;


                    showCartLoader();


                    try {

                        const response =
                            await fetch(
                                "/cart/add.js",
                                {
                                    method:
                                        "POST",

                                    headers: {
                                        "Content-Type":
                                            "application/json",

                                        "Accept":
                                            "application/json"
                                    },

                                    body:
                                        JSON.stringify(
                                            {
                                                id:
                                                    Number(
                                                        variantId
                                                    ),

                                                quantity:
                                                    1
                                            }
                                        )
                                }
                            );


                        if (!response.ok) {

                            const errorData =
                                await response.json();


                            throw new Error(
                                errorData.description ||
                                "Unable to add product."
                            );

                        }


                        await response.json();


                        /* Update header count */

                        await updateHeaderCart();


                        /* Change loader to success */

                        showCartSuccess();


                        /* Start cart sparkle animation */

                        celebrateCart();


                        /* Tell Shopify/theme listeners */

                        document.dispatchEvent(
                            new CustomEvent(
                                "cart:refresh"
                            )
                        );


                        document.dispatchEvent(
                            new CustomEvent(
                                "cart:updated"
                            )
                        );


                        /* Keep success visible briefly */

                        setTimeout(() => {

                            hideCartLoader();

                        }, 1000);

                    }

                    catch (error) {

                        console.error(
                            error
                        );


                        if (loaderTitle) {

                            loaderTitle.textContent =
                                "Something went wrong";

                        }


                        if (loaderText) {

                            loaderText.textContent =
                                error.message ||
                                "Please try again.";

                        }


                        setTimeout(() => {

                            hideCartLoader();

                        }, 1800);

                    }

                    finally {

                        button.disabled =
                            false;

                    }

                }
            );

        });

});